import { render, staticRenderFns } from "./DCardPanel.vue?vue&type=template&id=92c6753e"
import script from "./DCardPanel.vue?vue&type=script&lang=js"
export * from "./DCardPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QLinearProgress,QInfiniteScroll,QBtn,QTooltip});
